import hissaApi from "./hissaApi";
import {
  ScheduledReport,
  ScheduledReportRun,
  UpdateScheduleRequest,
  HissaReportType,
} from "../types/common";
import optionsApi from "./optionsApi";

export async function getScheduledReports(): Promise<ScheduledReport[]> {
  const res = await optionsApi.get("v1/scheduledReport");
  return res.data?.data ?? res.data ?? [];
}

export async function getScheduledReport(id: string): Promise<ScheduledReport> {
  const res = await optionsApi.get<ScheduledReport>(`v1/scheduledReport/${id}`);
  return res.data;
}

export async function updateScheduledReport(
  id: string,
  payload: UpdateScheduleRequest
): Promise<ScheduledReport> {
  const res = await optionsApi.patch<ScheduledReport>(
    `v1/scheduledReport/${id}`,
    payload
  );
  return res.data;
}

export async function deactivateScheduledReport(id: string): Promise<void> {
  await optionsApi.patch(`v1/scheduledReport/${id}/deactivate`);
}

export async function deleteScheduledReport(id: string): Promise<void> {
  await optionsApi.delete(`v1/scheduledReport/${id}`);
}

export async function skipScheduledReport(
  id: string
): Promise<ScheduledReport> {
  const res = await optionsApi.post<any>(`v1/scheduledReport/${id}/skip`);
  return res.data?.data ?? res.data;
}

export async function getScheduleRunHistory(
  id: string
): Promise<ScheduledReportRun[]> {
  const res = await optionsApi.get<any>(`v1/scheduledReport/${id}/runs`);
  return res.data?.data ?? res.data ?? [];
}
